export default __webpack_public_path__ + "static/mailchimp-d5bfb2bd886f2a8464bd3901402cf79c.svg";